import { getNextApiRoute } from './api';

function syncSfccSessionCookies() {
    const url = getNextApiRoute('session');
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export async function syncSfccSessionCookiesWithRetry() {
    const maxRetries = 3;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            await syncSfccSessionCookies();
            return;
        } catch (error) {
            console.error(
                `[syncSfccSessionCookiesWithRetry] Attempt ${attempt} failed:`,
                error
            );
            if (attempt === maxRetries) {
                throw new Error(
                    'Failed to synchronize SFCC session cookies after 3 attempts. Stopped retrying.'
                );
            }
        }
    }
}
